// Configuração do Google Analytics (via GTM / dataLayer)
export const GA_CONFIG = {
  // ID de medição do Google Analytics
  MEASUREMENT_ID: 'G-MB4XKH3QKL',

  // Configurações padrão
  DEFAULT_CONFIG: {
    send_page_view: true
  },

  // Categorias de eventos padrão
  EVENT_CATEGORIES: {
    BUTTON: 'button',
    FORM: 'form',
    DOWNLOAD: 'download',
    EXTERNAL_LINK: 'external_link',
    NAVIGATION: 'navigation',
    USER_ENGAGEMENT: 'user_engagement'
  },

  // Ações de eventos padrão
  EVENT_ACTIONS: {
    CLICK: 'click',
    SUBMIT: 'submit',
    DOWNLOAD: 'download',
    PAGE_VIEW: 'page_view',
    SCROLL: 'scroll'
  },

  // Labels de eventos específicos
  EVENT_LABELS: {
    // Botões de demonstração
    DEMO_BUTTON: 'demonstracao',
    CONSULTANT_BUTTON: 'consultor_especialista',
    APP_DOWNLOAD: 'baixar_app',

    // Páginas
    HOME_PAGE: 'home',
    CLINICA_MEDICA_PAGE: 'clinica_medica',
    SECRETARIADO_PAGE: 'secretariado',
    CIRURGIAO_PAGE: 'cirurgiao'
  }
};

// GTM é inicializado no main.jsx via initGTM() — aqui só garante o dataLayer
export const initializeGA = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
  }
};

// Eventos personalizados via dataLayer (GTM encaminha para GA4 / Pixel / Ads)
export const trackCustomEvent = (action, category, label, value) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: action,
    event_category: category,
    event_label: label,
    value: value,
  });
};

export const trackException = (description, fatal = false) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'exception',
    description,
    fatal,
  });
};

export const trackTimeOnPage = (timeInSeconds) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'timing_complete',
    name: 'page_view',
    value: timeInSeconds * 1000,
  });
};
